/* eslint-disable */

import { combineReducers } from 'redux'
import loginReducer from './loginReducer'
import snackBarReducer from './snackBarReducer'
import testReducer from './testReducer'
import assetsProducingReducer from './assetsProducingReducer'
import assetsConsumingReducer from './assetsConsumingReducer'
import dashboardReducer from './dashboardReducer'
import certificatesReducer from './certificatesReducer'
import reportsReducer from './reportsReducer'
import transportCertificatesReducer from './transportCertificatesReducer'
import utilsReducer from './utilsReducer'
import usersReducer from './usersReducer'
import organizationsReducer from './organizationsReducer'
import countriesReducer from './countriesReducer'
import matchingTypesReducer from './matchingTypesReducer'
import maintenanceReducer from './maintenanceReducer'
import logsReducer from './logsReducer'
import uploadAssetMeteringReducer from './Maintenance/uploadAssetMeteringReducer'
import { databaseServiceReducer } from "./Maintenance/databaseServiceReducer";
import { meteringServiceReducer } from "./Maintenance/meteringServiceReducer";
import { routerReducer } from 'react-router-redux'

export default combineReducers({
  loginReducer,
  snackBarReducer,
  testReducer,
  assetsProducingReducer,
  assetsConsumingReducer,
  certificatesReducer,
  reportsReducer,
  transportCertificatesReducer,
  utilsReducer,
  usersReducer,
  organizationsReducer,
  countriesReducer,
  matchingTypesReducer,
  maintenanceReducer,
  logsReducer,
  uploadAssetMeteringReducer,
  databaseServiceReducer,
  meteringServiceReducer,
  dashboardReducer,
  router: routerReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.js